import React from 'react';
import PropTypes from 'prop-types';

import PriceTag from './PriceTag';
import ProductImage from './ProductImage';
import ProductDetailTag from './ProductDetailTag';

const ProductTile = props => {
  const OptionalLinkTag = !!props.url ? 'a' : 'span';

  return (
    <div className="product-tile">
      <OptionalLinkTag className="product-tile__link" href={props.url}>
        <ProductImage
          src={props.imageUrl}
          starRating={props.starRating}
          detail={
            !!props.detail && (
              <ProductDetailTag>{props.detail}</ProductDetailTag>
            )
          }
        />

        <h2 className="product-tile__name natural-heading--small">
          {props.name}
        </h2>
      </OptionalLinkTag>

      {props.price && (
        <PriceTag
          price={props.price}
          discountPrice={props.discountPrice}
          compact={true}
        />
      )}

      {props.callToAction && (
        <div className="product-tile__call-to-action">{props.callToAction}</div>
      )}
    </div>
  );
};

ProductTile.propTypes = {
  callToAction: PropTypes.element,
  detail: PropTypes.string,
  discountPrice: PropTypes.element,
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.element,
  starRating: PropTypes.number,
  url: PropTypes.string,
};

export default ProductTile;
